import type { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { set } from '../../../store/Opportunity/MileStoneSchedule';

function MileStoneSchedule() {
  const dispatch = useDispatch();
  const mileStoneScheduleState = useSelector((state: RootState) => state.opportunity.mileStoneSchedule);

  const changeHandler = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className='mt-0 text-primaryColor-normal'>Milestone Schedule</h2>
      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Site Control<sup>*</sup>
        </label>
        <input type='text' name='siteControl' value={mileStoneScheduleState.siteControl} className='form-input' onChange={changeHandler} />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Design and Entitlements<sup>*</sup>
        </label>
        <input
          type='text'
          name='designAndEntitlements'
          value={mileStoneScheduleState.designAndEntitlements}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Acquisition<sup>*</sup>
        </label>
        <input type='text' name='acquisition' value={mileStoneScheduleState.acquisition} className='form-input' onChange={changeHandler} />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Financial Close<sup>*</sup>
        </label>
        <input
          type='text'
          name='financialClose'
          value={mileStoneScheduleState.financialClose}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Construction<sup>*</sup>
        </label>
        <input
          type='text'
          name='construction'
          value={mileStoneScheduleState.construction}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Project Completion<sup>*</sup>
        </label>
        <input
          type='text'
          name='projectCompletion'
          value={mileStoneScheduleState.projectCompletion}
          className='form-input'
          onChange={changeHandler}
        />
      </div>
    </>
  );
}

export default MileStoneSchedule;
